// pipe 4B.8b: consent-gated, NON-blocking GPS. Native uses @capacitor/geolocation (it
// triggers the Android runtime permission the bare WebView navigator.geolocation cannot);
// web keeps navigator.geolocation. Denial → 'denied' (completion still proceeds — GPS is
// exceeds-standard, ADISA §3.2.43 mandates only the signed chain-of-custody).
import type { Geo } from '../services/driver-erp';
import { isNative } from './platform';
export async function getPosition(): Promise<Geo | 'denied'> {
  if (isNative()) {
    try {
      const { Geolocation } = await import('@capacitor/geolocation');
      const perm = await Geolocation.requestPermissions();
      if (perm.location === 'denied') return 'denied';
      const p = await Geolocation.getCurrentPosition();
      return { lat: p.coords.latitude, lng: p.coords.longitude, accuracy_m: p.coords.accuracy };
    } catch { return 'denied'; }
  }
  if (!navigator.geolocation) return 'denied';
  return new Promise(resolve =>
    navigator.geolocation.getCurrentPosition(
      p => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy_m: p.coords.accuracy }),
      () => resolve('denied')
    )
  );
}
